import React, { useState } from "react";
import {
  Box,
  Typography,
  Button,
} from "@mui/material";
import ColorPicker from "react-best-gradient-color-picker";

const ColorsPicker = ({
  toggleDrawer,
  editItem = {},
  handleSave,
  initialColor = "#000000",
}) => {
  const [color, setColor] = useState(initialColor);
  // console.log(editItem, `-----------------------`);
  let showGradient = false;
  if (
    (editItem?.prevItem === "items" || editItem?.prevItem === "search") &&
    editItem?.key === "textColor"
  ) {
    showGradient = true;
  }
  const handlePickerSave = () => {
    if (!editItem?.key) {
      handleSave(editItem?.item, null, color);
      toggleDrawer(false);
    } else {
      handleSave(editItem?.prevItem, editItem?.key, color);
      toggleDrawer(editItem?.open, editItem?.index, editItem?.prevItem);
    }
  };

  return (
    <Box
      sx={{
        borderRadius: "5px",
        width: "100%",
        height: "auto",
        margin: "0 auto",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "space-between",
        backgroundColor: "#fff",
      }}
    >
      <Box
        sx={{
          width: "100%",
        }}
      >
        <Box
          sx={{
            backgroundColor: "#333",
            color: "#fff",
            padding: "7px 5px",
            marginBottom: "10px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography
            variant="h6"
            sx={{ fontWeight: "bold", fontSize: "16px" }}
          >
            Color Picker
          </Typography>
          {editItem?.item !== "bgColor" && (
            <Button
              variant="text"
              sx={{ fontWeight: "bold", color: "#fff" }}
              onClick={() => {
                toggleDrawer(true, editItem?.index, editItem?.prevItem);
              }}
            >
              Back
            </Button>
          )}
        </Box>
      </Box>
      <ColorPicker
        value={color}
        onChange={setColor}
        width={350}
        hideAdvancedSliders={true}
        hideColorGuide={true}
        hideInputType={true}
        hideColorTypeBtns={showGradient}
        style={{ cursor: "pointer" }}
      />
      <Button
        variant="contained"
        color="success"
        fullWidth
        sx={{
          fontSize: "12px",
          padding: "6px",
          width: "90%",
          borderRadius: "50px",
          margin: "30px 0 20px 0",
        }}
        onClick={handlePickerSave}
      >
        Save
      </Button>
    </Box>
  );
};

export default ColorsPicker;
